"use client";

/**
 * HalloweenBackground
 *
 * Background decorations for Halloween theme.
 * Part of the decoration system - controlled via NEXT_PUBLIC_ACTIVE_DECORATIONS.
 *
 * Minimal, fixed-position corner decorations for Halloween.
 */
export function HalloweenBackground() {
  return (
    <div aria-hidden="true" className="pointer-events-none select-none">
      {/* Top Left - Pinky */}
      <img
        src="/images/halloween/Pinky.webp"
        alt=""
        width={300}
        height={350}
        loading="lazy"
        decoding="async"
        className="fixed top-16 hidden xl:block xl:left-1/2 xl:-translate-x-[calc(50%+570px)] z-0"
      />

      {/* Top Right - Bonk */}
      <img
        src="/images/halloween/Bonk.webp"
        alt=""
        width={200}
        height={500}
        loading="lazy"
        decoding="async"
        className="fixed -top-12 hidden xl:block xl:right-1/2 xl:translate-x-[calc(50%+630px)] z-0"
      />

      {/* Bottom Left - Curio */}
      <img
        src="/images/halloween/Curio.webp"
        alt=""
        width={130}
        height={150}
        loading="lazy"
        decoding="async"
        className="fixed -bottom-16 left-4 hidden xl:block z-0"
      />

      {/* Bottom Right - Slurp */}
      <img
        src="/images/halloween/Slurp.webp"
        alt=""
        width={160}
        height={150}
        loading="lazy"
        decoding="async"
        className="fixed top-[58%] hidden xl:block xl:left-1/2 xl:-translate-x-[calc(50%+540px)] z-0"
      />

      {/* Bottom Right - Pumpkins */}
      <img
        src="/images/halloween/Pumpkins.webp"
        alt=""
        width={160}
        height={150}
        loading="lazy"
        decoding="async"
        className="fixed bottom-0 right-0 hidden xl:block z-0"
      />
    </div>
  );
}
